var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSortUnsorted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.334 4a.667.667 0 0 0-.667-.667H3.334a.667.667 0 1 0 0 1.334h9.333A.667.667 0 0 0 13.334 4m-2.667 3.334a.667.667 0 1 1 0 1.333H3.334a.667.667 0 0 1 0-1.333zm-2 4a.667.667 0 0 1 0 1.333H3.334a.667.667 0 1 1 0-1.333z",
  clipRule: "evenodd"
})));
export default SvgGemSortUnsorted;